<template>
  <div id="message-input-wrapper">
    <textarea
      class="message-input"
      v-model="messageBody"
      placeholder="Write a message..."
      @keyup.enter="sendMessage"
    />
    <round-button-with-icon icon="plane" />
  </div>
</template>
<script>
import RoundButtonWithIcon from "../../UI/RoundButtonWithIcon.vue";
// import RoundIconButton from "../../SharedComponentsUI/RoundIconButton.vue";
export default {
  data() {
    return {
      messageBody: undefined,
    };
  },
  methods: {
    sendMessage() {
      if (!this.conversationLoading) {
        this.$emit("send-message", this.messageBody);
        this.messageBody = undefined;
      }
    },
  },
  components: {
    RoundButtonWithIcon,
  },
  props: ["conversationLoading"],
  emits: ["send-message"],
};
</script>
<style scoped>
#message-input-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding-top: 10px;
  max-height: 30%;
}

.message-input {
  width: 100%;
  max-height: 100%;
  outline: none;
  border: none;
  height: 20px;
  border-radius: 9px;
  filter: drop-shadow(0px 1px 1px var(--shadow));
  padding-left: 10px;
  resize: none;
  font-size: 12px;
  font-family: Raleway, sans-serif;
}

.send-button {
  margin-right: 0;
}
</style>
